















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { convertCharAndConvertToHtml } from '@/heplers';
import { translation } from '@/templates/References';

@Component({})
export default class Returns extends Vue {
  @Prop(Array) returns: Array<string | translation>;

  convertToHtml(mdString: string) {
    if (typeof mdString == 'object') return mdString;
    else return convertCharAndConvertToHtml(mdString);
  }
}
